import React from "react";

const Java_split = () => {
  return (
    <div>
      <h1>Java split</h1>
      <p>This page provides explanations, examples, and common use-cases for Java split in Java.</p>
    </div>
  );
};

export default Java_split;
